import { ModalService } from './../../../../common/services/modal/modal.service';
import { VisitorEventService } from './../../services/visitor.event.service';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { VisitorEvent } from 'src/app/modules/shared/models/visitor.event';
import { CalendarQueryCommand } from 'src/app/modules/shared/models/calendar.action.command';
import { BaseComponent } from 'src/app/common/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { FancyEventDetailsModalComponent } from '../event.details.modal/fancy.event.details.modal/fancy.event.details.modal.component';
import { IEventDetailsModalData } from '../event.details.modal/event.details.modal.provider';

@Component({
  selector: 'ig-upcoming-events',
  templateUrl: './upcoming.events.component.html',
  styleUrls: ['./upcoming.events.component.scss'],
})
export class UpcomingEventsComponent extends BaseComponent implements OnInit {
  isLoading = false;
  upcomingEvents = [];
  isHavingScroll = false;

  @Input() currentEvent: VisitorEvent;
  @Input() allEvents: VisitorEvent[] = [];
  @Input() mode: 'normal' | 'fancy' = 'normal';

  @ViewChild('container', { static: true }) container: ElementRef;

  @Output() public onUpcomingEventClick = new EventEmitter();
  @Output() public onMoreClick = new EventEmitter();

  constructor(
    public activatedRoute: ActivatedRoute,
    private _eventService: VisitorEventService,
    private _modalService: ModalService
  ) {
    super({ activatedRoute });
    const { hubName } = this.allRouteParams;
    this.hubName = hubName;
  }

  ngOnInit(): void {
    this.isLoading = true;

    // there is a problem when loading upcoming events from server, the event index will be reverted, but not a big issue
    const fromIndex = this.allEvents
      ? this.allEvents.findIndex((x) => x._id === this.currentEvent._id) + 1
      : 0;

    if (fromIndex && fromIndex + 4 <= this.allEvents.length) {
      this.upcomingEvents = this.allEvents.slice(fromIndex, fromIndex + 4);
      this.isLoading = false;
      this.checkIsHaveScroll();
    } else {
      this.loadEventsFromServer();
    }
  }

  public upcomingEventClick(event?: VisitorEvent) {
    /**
     * if visit upcoming event from an event details page which was opened from a place details page, then show it in a new window
       to make it clear, the process is: 
       1. visit a place details page
       2. click on the nearby events, then show the event details page in a new popup window, covers the first place details page popup
       3. if now click to visit another uncoming event from the previous event details page, show the new event details page in a new tab window
       so if the current location contains both the imgoing-place and imgoing-event that means it needs to open in a new window       
     *  */
    if (
      window.location.href.includes('imgoing-place=') &&
      window.location.href.includes('imgoing-event=')
    ) {
      const clientHref = window.location.href.substring(
        0,
        window.location.href.indexOf('imgoing-')
      );
      const eventHref = `${clientHref}imgoing-event=${event.nameId}`;
      window.open(eventHref, '_blank');
    } else {
      this._modalService.show<FancyEventDetailsModalComponent>({
        component: FancyEventDetailsModalComponent,
        panelClass: 'ig-modal-w-full',
        data: {
          currentEvent: event,
          allEvents: this.allEvents,
        } as IEventDetailsModalData,
      });
      this.onUpcomingEventClick.emit();
    }
  }

  public more() {
    this.onMoreClick.emit();
  }

  private loadEventsFromServer() {
    this._eventService
      .getEvents(this.hubName, {
        isForUpcoming: true,
        id: this.currentEvent._id,
      } as CalendarQueryCommand)
      .subscribe((events) => {
        this.upcomingEvents = events.splice(1);
        this.isLoading = false;
        this.checkIsHaveScroll();
      });
  }

  private checkIsHaveScroll() {
    setTimeout(() => {
      this.isHavingScroll =
        this.container?.nativeElement.offsetHeight <
        this.container?.nativeElement.scrollHeight;
    });
  }
}
